//map, drawer?
export const AUDIO_MAIN = '|A|AUDIO_MAIN'
export const AUDIO_TOUR = 'AUDIO_TOUR'
export const AUDIO_SUPP = 'AUDIO_SUPP'
export const AUDIO_PM = 'AUDIO_PM'
export const AUDIO_HS = 'AUDIO_HS'
export const AUDIO_TRIGGER = 'AUDIO_TRIGGER' //hover the audio element

export const AUDIO_OPT_IN = 'AUDIO_OPT_IN'

export const AUDIO_PLAY = 'AUDIO_PLAY'
export const AUDIO_STOP = '|A|AUDIO_STOP'
export const AUDIO_LOAD = 'AUDIO_LOAD'

export const AUTO_PLAY = 'AUTO_PLAY'

export const playAudio = name => ({
    type: AUDIO_PLAY,
    name,
})

export const stopAudio = name => ({
    type: AUDIO_STOP,
    name,
})

export const loadAudio = name => ({
    type: AUDIO_LOAD,
    name,
})

export const optIn = () => ({
    type: AUDIO_OPT_IN,
})

export const setAutoPlay = autoPlay => ({
    type: AUTO_PLAY,
    autoPlay,
})
